// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c15bbd5a","838":"152ab515"}[chunkId] + ".chunk.js";
};